interface IRef {
  redirect: () => void;
}

class RedirectManager {
  defaultRedirect: IRef | null = null;

  register(ref: IRef) {
    this.defaultRedirect = ref;
  }

  getDefault() {
    return this.defaultRedirect;
  }
}
export default new RedirectManager();
